module.exports = __webpack_public_path__ + "static/media/cpg_mobile_instagram_display.f98b2f16.png";